import React, {Component} from 'react';
import {Row, Col} from 'react-bootstrap';
import Gallery from 'react-photo-gallery';
import Lightbox from 'react-images';
import '../../assets/css/Galeria.css';
import OwlCarousel from "react-owl-carousel";

class Galeria extends Component {

    constructor(props) {
        super(props);
        this.state = {currentImage: 0};
        this.closeLightbox = this.closeLightbox.bind(this);
        this.openLightbox = this.openLightbox.bind(this);
        this.gotoNext = this.gotoNext.bind(this);
        this.gotoPrevious = this.gotoPrevious.bind(this);

    }

    openLightbox(event, obj) {
        this.setState({
            currentImage: obj.index,
            lightboxIsOpen: true,
        });
    }

    closeLightbox() {
        this.setState({
            currentImage: 0,
            lightboxIsOpen: false,
        });
    }

    gotoPrevious() {
        this.setState({
            currentImage: this.state.currentImage - 1,
        });
    }

    gotoNext() {
        this.setState({
            currentImage: this.state.currentImage + 1,
        });
    }

    render() {
        return (

            <div className="">
                <div>
                    <Gallery columns={1} margin="0" photos={this.props.photos} onClick={this.openLightbox}/>
                    <Lightbox images={this.props.photos}
                              onClose={this.closeLightbox}
                              onClickPrev={this.gotoPrevious}
                              onClickNext={this.gotoNext}
                              currentImage={this.state.currentImage}
                              isOpen={this.state.lightboxIsOpen}
                    />
                </div>
            </div>
        );
    }
}

export default Galeria;